// extracted by mini-css-extract-plugin
module.exports = {"container":"Paginator_container__2fibO","paginatorInput":"Paginator_paginatorInput__1wjFo","leftArrow":"Paginator_leftArrow__2HQTQ","rightArrow":"Paginator_rightArrow__2h3y-"};